<!--
 * @Author: zl
 * @Date: 2022-11-10 10:44:20
 * @LastEditTime: 2022-11-15 13:47:48
 * @LastEditors: zl
 * @Description: 标签管理 --- 平台标签维护
-->
<template>
	<div class='tag-maintain-layout'>
		<wSplit class="h100"
				v-model="splitV">
			<div class="left filter-layout"
				 slot="left">
				<div class="filter-box">
					<div class="flex mb10 header-box">
						<el-input v-model="leftObj.searchName"
								  size="small"
								  placeholder="请输入">
							<el-button slot="append"
									   type="primary"
									   size="small"
									   icon="el-icon-search"
									   @click="getLeftData"></el-button>
						</el-input>
						<el-button size="small"
								   class="ml10"
								   type="primary"
								   @click="addTagGroup">新增分组</el-button>
					</div>
				</div>
				<div class="filter-content w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table align="center"
								   auto-resize
								   border
								   :data="leftObj.data"
								   :loading="leftObj.loading"
								   height="100%"
								   highlight-hover-row
								   highlight-current-row
								   resizable
								   size="small"
								   ref="leftTable"
								   show-overflow="tooltip"
								   show-header-overflow="tooltip"
								   @current-change="currentClick">
							<vxe-column type="seq"
										title="序号"
										width="70"></vxe-column>
							<vxe-column title="分组名"
										field="sname"
										header-align="center"
										align="left"></vxe-column>
							<vxe-column title="业务板块"
										field="applysName"
										header-align="center"
										align="left"></vxe-column>
						</vxe-table>
					</div>
				</div>
			</div>
			<div class="right filter-layout"
				 slot="right">
				<div class="filter-box"
					 v-if="searchToggle">
					<el-form :model="searchForm"
							 label-width="80px"
							 ref="searchForm"
							 size="small">
						<el-row>
							<el-col :span="6">
								<el-form-item label="标签名称"
											  prop="sname">
									<el-input v-model="searchForm.sname"
											  placeholder="请输入"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="创建人"
											  prop="createUser">
									<el-input v-model="searchForm.createUser"
											  placeholder="请输入"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="业务板块"
											  prop="applys">
									<el-select v-model="searchForm.applys"
											   placeholder="请选择">
										<el-option v-for="(item, index) in typeList"
												   :key="'yewu' + index"
												   :label="item.sname"
												   :value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label-width="20px">
									<el-button type="primary"
											   @click="onSearch">搜索</el-button>
									<el-button type="warning"
											   @click="onRefresh">重置</el-button>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<div class="filter-content primary-layout">
					<div class="primary-header">
						<div class="left-btn"></div>
						<div class="btnGroups">
							<el-button v-if="roleBtns.includes('tagMaintenance-add')"
									   type="primary"
									   size="small"
									   @click="handleTag('add')">新增标签</el-button>
							<el-button type="warning"
									   size="small"
									   icon="el-icon-setting"
									   @click="searchToggle = !searchToggle"></el-button>
						</div>
					</div>
					<div class="primary-content w-table-layout w-table-page">
						<div class="w-table-content">
							<vxe-table align="center"
									   auto-resize
									   border
									   :data="tableObj.tableData"
									   :loading="tableObj.loading"
									   height="100%"
									   highlight-hover-row
									   highlight-current-row
									   resizable
									   ref="rightTable"
									   size="small"
									   show-overflow="tooltip"
									   show-header-overflow="tooltip">
								<vxe-column type="seq"
											title="序号"
											width="70px"></vxe-column>
								<vxe-column field="sname"
											title="标签名称"
											min-width="185px"
											align="left"
											header-align="center"></vxe-column>
								<vxe-column field="type"
											title="标签类型"
											width="150px">
									<template v-slot="{ row }">
										{{ row.type === 1 ? "公共标签" : "个人标签" }}
									</template>
								</vxe-column>
								<vxe-column field="applysName"
											title="业务板块"
											width="150px"></vxe-column>
								<vxe-column field="createUser"
											title="创建人"
											width="150px"></vxe-column>
								<vxe-column field="createDate"
											title="创建时间"
											width="150px"></vxe-column>
								<vxe-column field="status"
											title="标签状态"
											width="120px">
									<template v-slot="{ row }">
										<vxe-switch v-model="row.status"
													open-label="启用"
													:open-value="1"
													close-label="禁用"
													:close-value="0"
													disabled
													:class="{ opacityHide: !roleBtns.includes('tagMaintenance-enable') }"
													@click.native.prevent="handleTag('change', row)"></vxe-switch>
									</template>
								</vxe-column>
								<vxe-column title="操作"
											width="120px">
									<template v-slot="{ row }">
										<el-button type="text"
												   :disabled="row.type === 0"
												   icon="el-icon-edit"
												   title="编辑"
												   class="mr20"
												   v-if="roleBtns.includes('tagMaintenance-edit')"
												   @click="handleTag('edit', row)"></el-button>
										<el-button type="text"
												   icon="el-icon-delete"
												   title="删除"
												   :disabled="row.type === 0"
												   v-if="roleBtns.includes('tagMaintenance-del')"
												   @click="handleTag('delete', row)"></el-button>
									</template>
								</vxe-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<el-pagination @size-change="handleSizeChange"
										   @current-change="handleCurrentChange"
										   :current-page="tableObj.currentPage"
										   :page-size="tableObj.pageSize"
										   :page-sizes="[10, 20, 50, 100]"
										   layout="total, sizes, prev, pager, next, jumper"
										   :total="tableObj.total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</wSplit>

		<!-- 添加分组弹窗 -->
		<el-dialog title="添加"
				   :visible.sync="leftDiaObj.show"
				   :close-on-click-modal="false"
				   width="800px"
				   :before-close="doCancel"
				   :destroy-on-close="true">
			<el-form :model="leftDiaObj.form"
					 ref="addForm"
					 label-width="140px"
					 size="small">
				<el-form-item label="分组标签名称"
							  prop="sname"
							  :rules="requireRule">
					<el-input v-model="leftDiaObj.form.sname"
							  clearable
							  placeholder="请输入"
							  maxlength="30"
							  show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="业务板块"
							  prop="applys"
							  :rules="requireRule">
					<el-select v-model="leftDiaObj.form.applys"
							   placeholder="请选择"
							   multiple
							   clearable>
						<el-option v-for="item in businessList"
								   :key="'applys' + item.id"
								   :label="item.sname"
								   :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer"
				 class="text-center">
				<el-button size="small"
						   @click="doCancel">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="leftDiaObj.loading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 新增、编辑弹窗 -->
		<el-dialog :visible.sync="rightDiaObj.show"
				   :title="rightDiaObj.title"
				   width="800px"
				   :close-on-click-modal="false"
				   :before-close="doClosed"
				   :destroy-on-close="true">
			<el-form label-width="120px"
					 :model="rightDiaObj"
					 ref="tagForm"
					 size="small">
				<el-form-item label="标签名"
							  prop="sname"
							  :rules="requireRule">
					<el-input placeholder="请输入"
							  v-model.trim="rightDiaObj.sname"
							  :maxlength="20"
							  show-word-limit></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer"
				 class="pdb10 text-center">
				<el-button size="small"
						   @click="doClosed">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="rightDiaObj.loading"
						   @click="doSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import * as API from '@/api/modules/tag_management'
export default {
	props: {},
	components: {},
	data() {
		return {
			splitV: 0.2, //左右比例
			searchToggle: true, //控制搜索条件显隐
			businessList: [], //业务板块
			// 必填规则
			requireRule: [{ required: true, message: '不能为空' }],
			// 左侧表格
			leftObj: {
				data: [],
				loading: false,
				searchName: '',
				selectObj: {},
			},
			// 右侧表格查询条件
			searchForm: {
				sname: '', // 标签名称
				type: '', // 标签类型 （0个人、1公共）
				createUser: '', // 创建人
				applys: '',
			},
			// 右侧表格参数
			tableObj: {
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				loading: false,
				show: true,
			},

			// 左侧弹窗相关
			leftDiaObj: {
				show: false,
				data: [],
				loading: false,
				form: {
					sname: '', //分组标签名称
					applys: [], //标签适用对象 多值逗号分割
				},
			},

			// 右侧侧弹窗对象
			rightDiaObj: {
				show: false,
				loading: false,
				title: '',
				type: '',
				sname: '', // 标签名
				currentObj: {},
			},
		}
	},
	created() {
		// 获取左侧表格数据
		this.getLeftData(true)
		// 获取码表
		this.getDictList()
	},
	mounted() {},
	methods: {
		/**
		 * @description: 准备工作
		 */

		// 获取左侧表格数据
		getLeftData(first) {
			this.leftObj.loading = true
			API.selectGroupData({
				sname: this.leftObj.searchName,
			})
				.then((res) => {
					let { records } = res.data
					this.leftObj.loading = false
					this.leftObj.data = this.$utils.clone(records, true)
					// 进入页面默认选中第一条数据
					if (first && records.length > 0) {
						this.leftObj.selectObj = records[0]
						// 获取右侧表格数据
						this.getRightData()
						setTimeout(() => {
							this.$refs.leftTable.setCurrentRow(
								this.leftObj.data[0]
							)
						}, 100)
						return
					}
					// 新增分组后刷新列表，如果之前已经选中某一行，则设置该行选中
					if (this.leftObj.selectObj.id) {
						let index = this.leftObj.data.findIndex(
							(x) => x.id == this.leftObj.selectObj.id
						)
						this.$refs.leftTable.setCurrentRow(
							this.leftObj.data[index]
						)
					}
				})
				.catch(() => {
					this.leftObj.loading = false
				})
		},

		// 获取右侧表格数据
		getRightData() {
			let params = this.$utils.clone(this.searchForm, true)
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			params.groupId = this.leftObj.selectObj.id
			this.tableObj.loading = true
			API.getTagsList(params)
				.then((res) => {
					this.tableObj.loading = false
					let { records, total } = res.data
					this.tableObj.tableData = records
					this.tableObj.total = parseInt(total)
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		// 获取码表
		getDictList() {
			API.selectSysDictByParent({ value: '1056' }).then((res) => {
				this.businessList = res.data
			})
		},

		/**
		 * @description: 左侧表格相关
		 */

		// 新增分组
		addTagGroup() {
			this.leftDiaObj.show = true
		},

		// 左侧表格点击
		currentClick({ row }) {
			this.leftObj.selectObj = this.$utils.clone(row, true)
			this.onSearch()
		},

		/**
		 * @description: 右侧表格相关
		 */

		// 搜索事件
		onSearch() {
			this.tableObj.currentPage = 1
			this.getRightData()
		},

		// 重置事件
		onRefresh() {
			this.$refs.searchForm.resetFields()
			this.onSearch()
		},

		// 按钮点击事件
		handleTag(type, row) {
			switch (type) {
				case 'add':
					if (!this.leftObj.selectObj.id) {
						this.$message.warning('请选择要添加标签的分组！')
						return
					}
					this.rightDiaObj.title = '新增'
					break
				case 'edit':
					this.rightDiaObj.title = '编辑'
					this.rightDiaObj.currentObj = this.$utils.clone(row, true)
					this.rightDiaObj.sname = row.sname
					break
				case 'delete':
					this.deleteTag(row)
					return
				case 'change':
					this.changeTag(row)
					return
			}
			this.rightDiaObj.show = true
			this.rightDiaObj.type = type
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tableObj.pageSize = size
			this.getRightData()
		},

		// 表格 页码切换
		handleCurrentChange(current) {
			this.tableObj.currentPage = current
			this.getRightData()
		},

		// 切换标签状态（启用、禁用）
		async changeTag(row) {
			if (this.roleBtns.includes('tagMaintenance-enable')) {
				let status = await this.$deleteConfirm(
					'此操作将改变该标签的状态, 是否继续?',
					true
				)
				if (status) {
					let params = this.$utils.clone(row, true)
					params.status = row.status == 0 ? 1 : 0
					API.setTagFlag(params).then((res) => {
						this.$message.success('设置成功！')
						this.getRightData()
					})
				} else {
					this.$message.info('已取消操作！')
				}
			} else {
				this.$message.warning('当前账号没权限进行此操作！')
			}
		},

		// 点击删除
		async deleteTag(row) {
			// 启用时不允许删除
			if (row.status === 1) {
				this.$message.warning('标签为启用状态，不允许删除！')
				return
			}

			let status = await this.$deleteConfirm('该标签')
			if (status) {
				API.deleteTag({ id: row.id }).then((res) => {
					if (res.operationCode === 1) {
						this.$message.success('删除成功!')
						this.getRightData()
					} else {
						this.$message.warning(res.msg)
					}
				})
			} else {
				this.$message.info('操作已取消！')
			}
		},

		/**
		 * @description: 左侧弹窗
		 */

		// 弹窗关闭
		doCancel() {
			this.$refs.addForm.resetFields()
			this.leftDiaObj.loading = false
			this.leftDiaObj.show = false
		},

		// 弹窗确定
		doSave() {
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					let params = this.$utils.clone(this.leftDiaObj.form, true)
					params.applys = params.applys.join(',')
					this.leftDiaObj.loading = true
					API.saveOrUpdateGroup(params)
						.then((res) => {
							if (res.operationCode === 1) {
								this.$message.success('添加完成！')
								this.doCancel()
								this.getLeftData()
							}
						})
						.catch(() => {
							this.leftDiaObj.loading = false
						})
					return
				}
				this.$message.error('请完善表单！')
			})
		},

		/**
		 * @description: 右侧弹窗
		 */

		// 弹窗关闭
		doClosed() {
			this.$refs.tagForm.resetFields()
			this.rightDiaObj.type = ''
			this.rightDiaObj.sname = ''
			this.rightDiaObj.id = ''
			this.rightDiaObj.loading = false
			this.rightDiaObj.show = false
		},

		// 弹窗确定
		doSubmit() {
			this.$refs.tagForm.validate((valid) => {
				if (valid) {
					let params = {}
					params.sname = this.rightDiaObj.sname
					params.groupId = this.leftObj.selectObj.id
					if (this.rightDiaObj.type == 'edit') {
						let { id, applys } = this.rightDiaObj.currentObj
						params.id = id
						params.applys = applys
					} else {
						params.applys = this.leftObj.selectObj.applys
					}
					this.rightDiaObj.loading = true
					API.saveOrUpdate(params)
						.then((res) => {
							if (res.operationCode === 1) {
								this.$message.success('保存成功！')
								this.doClosed()
								this.getRightData()
							}
						})
						.catch((err) => {
							this.rightDiaObj.loading = false
						})
					return
				}
				this.$message.error('请完善表单！')
			})
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		// 可用的业务板块
		typeList() {
			let showType,
				arr = []
			if (this.leftObj.selectObj.id) {
				showType = this.leftObj.selectObj.applys.split(',') || []
				if (this.businessList.length > 0) {
					arr = this.businessList.filter((x) =>
						showType.includes(x.value)
					)
				}
			}

			return arr
		},
	},
}
</script>

<style lang='less' scoped>
.tag-maintain-layout {
	padding: 0 !important;
	height: 100%;

	.left {
		padding-left: 0;
		/deep/ .el-input-group__append {
			color: #fff;
			background-color: #008080;
		}
	}
	.right {
		padding-right: 0;
	}
	.vxe-switch.is--disabled {
		opacity: 1;
		/deep/ .vxe-switch--button {
			cursor: pointer !important;
		}
	}
	/deep/ .is--on {
		.vxe-switch--button {
			background-color: #2671cc !important;
		}
	}
}
</style>